import { Dispatch, Action } from 'redux'
import { UserInvitesMainMapDispatchReturnType } from './types/UserInvitesMainMapDispatchReturnType'

export const UserInvitesMainMapDispatch = (
  _dispatch: Dispatch<Action>
): UserInvitesMainMapDispatchReturnType => {
  return {}
}
